import { useState, useEffect } from "react";
import logger from "../../../../util/logger";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import { query, collection, getDocs } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

function AdminRewardRedemptionHistoryPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);
  const [revealedDuis, setRevealedDuis] = useState({});

  const navigate = useNavigate();

  const [rewardHistory, setRewardHistory] = useState([]);
  const fetchRewardHistory = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "rewardRedemptions"));
      const docs = await getDocs(q);
      const history = docs.docs.map((doc) => doc.data());
      logger.debug("Fetched reward history:", history);
      setRewardHistory(history);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching reward history:", error);
    }
  };
  useEffect(() => {
    if (user) {
      fetchRewardHistory();
    }
    // eslint-disable-next-line
  }, [user]);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        REWARD REDEMPTION HISTORY
      </h1>
      <div style={{ marginTop: "2rem" }}>
        {rewardHistory.length === 0 ? (
          <p style={{ textAlign: "center" }}>No reward redemptions found</p>
        ) : (
          <div style={{ width: "100%", maxWidth: 900, overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                minWidth: 400,
                background: "#111835",
                borderRadius: 12,
                overflow: "hidden",
                color: "#fff",
                fontSize: "1rem",
              }}
            >
              <thead style={{ background: "#222a4d" }}>
                <tr>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontSize: "1rem",
                    }}
                  >
                    Redeemer
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontSize: "1rem",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontSize: "1rem",
                    }}
                  >
                    DUI
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontSize: "1rem",
                    }}
                  >
                    Cost
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontSize: "1rem",
                    }}
                  >
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {rewardHistory.map((reward, idx) => (
                  <tr
                    key={reward.rewardUid || idx}
                    style={{ borderBottom: "1px solid #222a4d" }}
                  >
                    <td
                      style={{
                        padding: "1rem",
                        fontSize: "0.95rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {reward.redeemerUsername || "Unknown"}
                    </td>
                    <td
                      style={{
                        padding: "1rem",
                        fontSize: "0.95rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {reward.rewardName}
                    </td>
                    <td
                      style={{
                        padding: "1rem",
                        fontSize: "0.95rem",
                        color: "#ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: 120,
                      }}
                    >
                      {(() => {
                        const dui = reward.dui;
                        if (!dui) return "—";
                        const revealed = revealedDuis[reward.uid || idx];
                        const mask = (s) => {
                          if (!s) return "";
                          const trim = s.toString();
                          if (trim.length <= 4) return "•••" + trim;
                          return "••••-" + trim.slice(-4);
                        };
                        return (
                          <div
                            style={{
                              display: "flex",
                              gap: 8,
                              alignItems: "center",
                            }}
                          >
                            <span style={{ fontFamily: "monospace" }}>
                              {revealed ? dui : mask(dui)}
                            </span>
                            <button
                              onClick={() =>
                                setRevealedDuis((prev) => ({
                                  ...prev,
                                  [reward.uid || idx]: !prev[reward.uid || idx],
                                }))
                              }
                              style={{
                                background: "transparent",
                                color: "#9fb8ff",
                                border: "none",
                                cursor: "pointer",
                                padding: 0,
                                fontSize: 12,
                              }}
                            >
                              {revealed ? "Hide" : "Show"}
                            </button>
                          </div>
                        );
                      })()}
                    </td>
                    <td
                      style={{
                        padding: "1rem",
                        color: "#FABB00",
                        fontSize: "0.95rem",
                      }}
                    >
                      {reward.rewardPriceInTickets}
                    </td>
                    <td
                      style={{
                        padding: "1rem",
                        color: "#aaa",
                        fontSize: "0.95rem",
                        minWidth: 120,
                      }}
                    >
                      {reward.redemptionDate?.seconds
                        ? new Date(
                            reward.redemptionDate.seconds * 1000
                          ).toLocaleString()
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminRewardRedemptionHistoryPage;
